/* eslint-disable indent */
export const convertCurrentToPrevBookingData = (current) => {
    return {
        awbNumber: parseInt(current.documentNo),
        parentAwbNumber: null,
        bookingStartTime: current.createdAt,
        premiseId: null,
        userId: null,
        destinationPincode: parseInt(current.receiverAddress?.zip) || 0,
        location: null,
        cancellationReason: null,
        addressDetails: {
            addressDetailsId: current.pickupAddress?.id || 0,
            senderName: current.pickupAddress?.name || "",
            senderAddressLine1: current.pickupAddress?.address1 || "",
            senderAddressLine2: current.pickupAddress?.address2 || "",
            senderMobileNumber: parseInt(current.pickupAddress?.phone) || "",
            senderCity: current.pickupAddress?.city || "",
            senderState: current.pickupAddress?.state || "",
            senderPincode: parseInt(current.pickupAddress?.zip) || 0,
            customerId: 0,
            receiverName: current.receiverAddress?.name || "",
            receiverAddressLine1: current.receiverAddress?.address1 || "",
            receiverCity: current.receiverAddress?.city || "",
            receiverState: current.receiverAddress?.state || "",
            receiverPincode: parseInt(current.receiverAddress?.zip) || 0,
            receiverMobileNumber: parseInt(current.receiverAddress?.phone) || 0,
            receiverEmail: current.receiverAddress?.email || "",
            isGoogleAddress: false,
        },
        metadata: current.metadata,
        shipmentDetails: {
            awbNumber: parseInt(current.documentNo),
            type: current.shipmentType?.toLowerCase() || "",
            description: current.metadata?.remark,
            content: current.metadata?.content || "",
            value: parseFloat(current.metadata?.value) || 0,
            weight: parseFloat(current.dwsWeight) / 1000 || 0,
            length: parseFloat(current.dwsLength) || 0,
            width: parseFloat(current.dwsWidth) || 0,
            height: parseFloat(current.dwsHeight) || 0,
            volumetricWeight: parseFloat(current?.volumentricWeight || current?.volumetricWeight) || 0,
            destinationHubId: 15,
            pickupPincode: parseInt(current.pickupAddress?.zip) || 0,
            destinationPincode: parseInt(current.receiverAddress?.zip) || 0,
            premiseId: current.companyId || 0,
            bookingStartTime: current.createdAt,
            bookingCompleteTime: current.createdAt,
            bookingStatus: current.status,
            travelBy: current.travelBy?.toLowerCase() || "",
            parentPremiseId: 17,
            updatedDate: current.updatedAt,
            bookingType: current.bookingType,
            destinationCity: current.receiverAddress?.city || "",
            destinationState: current.receiverAddress?.state || "",
            insured: current.metadata?.insured || false,
            clientName: current.pickupAddress?.name || "",
            clientCity: current.pickupAddress?.city || "",
            branchName: "",
            state: current.pickupAddress?.state || "",
            stateCode: "",
            clientId: current.clientId || 0,
            modeOfPayment: current.charges?.mode || "",
        },
        serviceDetails: {
            service: current.deliveryPromise?.toLowerCase() || "standard",
            travelBy: current.travelBy?.toLowerCase() || "surface",
        },
        charges: {
            charges: parseFloat(current.charges?.charges) || 0,
            basecharge: 0,
            fov: parseFloat(current.metadata?.fov) || 0,
            cod: 0,
            igst: parseFloat(current.charges?.igst) || 0,
            sgst: parseFloat(current.charges?.sgst) || 0,
            cgst: parseFloat(current.charges?.cgst) || 0,
            cess: 0,
            freight: parseFloat(current.charges?.freight) || 0,
            promotionId: "0",
            discount: parseFloat(current.charges?.discountPercent) || 0,
            packagingCharge: parseFloat(current.charges?.packagingCharge) || 0,
            totalCharge: parseFloat(current.charges?.totalCharge) || 0,
            invoiceNumber: current.metadata?.invoiceNo || "",
            amount: parseFloat(current?.charges?.amount) || "",
        },
        childShipmentDetails: current.childShipments?.map(child => ({
            childShipmentId: child.id || null,
            childAwbNumber: parseInt(child.documentNo) || null,
            awbNumber: parseInt(current.documentNo),
            type: null,
            description: "",
            value: parseFloat(child.value) || 0,
            weight: parseFloat(child.dwsWeight) / 1000 || 0,
            volumetricWeight: parseFloat(child.volumetricWeight) || 0,
            length: parseFloat(child.dwsLength) || 0,
            width: parseFloat(child.dwsWidth) || 0,
            height: parseFloat(child.dwsHeight) || 0,
            service: null,
            ewayBillNumber: null,
            destinationPincode: null,
            destinationCpId: null,
            destinationHubId: null,
            bookingStatus: null,
            premiseId: 0,
            travelBy: null,
            readinessStatus: null,
            createdDate: child.createdAt,
            updatedDate: child.updatedAt,
            ewayBillCreateDate: null,
            expiryDate: null,
            deliverycount: null,
            extendEwayBillCount: null,
            oldAwbNumber: null,
            bookingType: null,
            reattemptedDate: null,
            oldEwayBillNumber: null,
            receiverAreaId: null,
            serviceType: null,
        })) || [],
        files: current.documents?.map(doc => ({
            id: null,
            awbNumber: parseInt(current.documentNo),
            fileName: doc.documentLink || "",
            fileId: doc.documentType || "",
        })) || [],
        ewaybills: current.eWayBills.map(eway => ({
            ewayBillNumber: eway.eway,
            expiryDate: eway.date,
            ewayBillCreateDate: eway.date || "",
            transMode: eway.transMode || "",
            name: eway.name || "",


        })) || [],

        bookingStatus: null,
        booking_Status: current.status,
        cpName: current.username || "",
        cpNum: null,
        delieveryFailureDto: null,
        oldAwbNumber: null,
        bookingType: current.bookingType,
        destinationCpName: null,
        returnAddressDetail: [],
        local: false,

    };
};


